// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1Naej","comment":"styles_comment__368Sa"};